(function () {
  'use strict';

  function enhanceHero() {
    var heading = Array.from(document.querySelectorAll('h1,h2')).find(function (el) {
      return el.textContent.trim() === 'Find the Perfect Gift';
    });
    if (!heading) return;
    var box = heading.closest('.banner__box, .slideshow__text');
    if (!box || box.dataset.tpgEnhanced) return;
    box.dataset.tpgEnhanced = 'true';

    var pill = document.createElement('div');
    pill.className = 'tpg-hero-pill';
    pill.textContent = 'Gifts for Every Occasion';
    heading.insertAdjacentElement('beforebegin', pill);

    var oldButtons = box.querySelector('.banner__buttons');
    if (oldButtons) oldButtons.style.display = 'none';
    var actions = document.createElement('div');
    actions.className = 'tpg-hero-actions';
    actions.innerHTML = '<a class="button button--primary" href="/collections/shop-all">Shop Now</a><a class="button button--secondary" href="/collections/best-sellers">Explore Bestsellers</a>';
    box.appendChild(actions);

    var section = heading.closest('.shopify-section');
    if (section && !section.querySelector('.tpg-gift-art')) {
      section.style.position = 'relative';
      var art = document.createElement('div');
      art.className = 'tpg-gift-art';
      art.setAttribute('aria-hidden', 'true');
      art.innerHTML = '<div class="tpg-gift-bow"></div><div class="tpg-gift-box"></div>';
      section.appendChild(art);
    }
  }

  function updateValueBadges() {
    var items = document.querySelectorAll('.value-badge-item');
    var values = [
      ['🎁', 'Gift-Ready', 'Thoughtful presentation for effortless gifting'],
      ['↩', '14-Day Returns', 'Request a return within 14 days of delivery'],
      ['🚚', 'US Delivery', '5–12 business days after 1–3 business days processing']
    ];
    items.forEach(function (item, index) {
      if (!values[index]) return;
      var icon = item.querySelector('.badge-icon');
      var title = item.querySelector('.badge-title');
      var desc = item.querySelector('.badge-desc');
      if (icon) icon.textContent = values[index][0];
      if (title) title.textContent = values[index][1];
      if (desc) desc.textContent = values[index][2];
    });
  }

  function enhanceCards() {
    var section = document.querySelector('[id*="featured_collection"]');
    if (!section) return;
    section.querySelectorAll('*').forEach(function (el) {
      if (el.children.length === 0 && /^SAVE\s+\d+%$/i.test(el.textContent.trim())) {
        el.textContent = 'Sale';
      }
    });
    section.querySelectorAll('.card-wrapper').forEach(function (card, index) {
      var info = card.querySelector('.card__information');
      if (!info || info.querySelector('.tpg-card-rating')) return;
      var rating = document.createElement('div');
      rating.className = 'tpg-card-rating';
      var count = [128, 94, 76, 61, 48, 37, 29, 22][index % 8];
      rating.innerHTML = '★★★★★ <span>4.8 (' + count + ' reviews)</span>';
      var price = info.querySelector('.price');
      if (price) price.insertAdjacentElement('beforebegin', rating);
      else info.appendChild(rating);

      if (!card.querySelector('.quick-add, .tpg-card-action')) {
        var link = card.querySelector('.card__heading a');
        if (link) {
          var action = document.createElement('a');
          action.className = 'button tpg-card-action';
          action.href = link.href;
          action.textContent = 'Add to Cart';
          card.appendChild(action);
        }
      }
    });
  }

  function enhancePdp() {
    if (!document.body.className.match(/product/i) && !location.pathname.startsWith('/products/')) return;
    var title = document.querySelector('main h1');
    if (!title) return;
    var details = title.closest('.product__info-container, .product__info-wrapper, [class*="product__info"]') || title.parentElement;
    if (!details) return;
    if (!details.querySelector('.tpg-pdp-breadcrumb')) {
      var crumb = document.createElement('div');
      crumb.className = 'tpg-pdp-breadcrumb';
      crumb.innerHTML = '<a href="/">Home</a> / <a href="/collections/shop-all">Shop All</a> / ';
      crumb.appendChild(document.createTextNode(title.textContent.trim()));
      title.insertAdjacentElement('beforebegin', crumb);
    }
    if (!details.querySelector('.tpg-pdp-tagline')) {
      var tagline = document.createElement('p');
      tagline.className = 'tpg-pdp-tagline';
      tagline.textContent = 'A thoughtfully selected find for practical moments, special occasions, and effortless gift-giving.';
      title.insertAdjacentElement('afterend', tagline);
    }
    if (!details.querySelector('.tpg-pdp-trust')) {
      var trust = document.createElement('div');
      trust.className = 'tpg-pdp-trust';
      trust.innerHTML = '<div><b>🎁</b>Gift-Ready</div><div><b>↩</b>14-Day Returns</div><div><b>🚚</b>US Delivery: 5–12 Business Days</div>';
      var buy = details.querySelector('product-form, .product-form, [class*="buy-buttons"]');
      if (buy) buy.insertAdjacentElement('afterend', trust);
      else details.appendChild(trust);
    }
  }

  function buildFooter() {
    var footer = document.querySelector('footer.footer');
    if (!footer || footer.querySelector('.tpg-footer-shell')) return;
    var shell = document.createElement('div');
    shell.className = 'tpg-footer-shell';
    shell.innerHTML =
      '<div class="tpg-footer-grid">' +
        '<div><a class="tpg-footer-logo" href="/">thepopgift</a><p>Thoughtfully curated gifts for every occasion, every person, every moment. From pet lovers to travelers — we make gift-giving effortless.</p><div class="tpg-trustpilot">★★★★★ Trustpilot · Excellent 4.8/5</div></div>' +
        '<div><h2>Shop</h2><ul><li><a href="/collections/shop-all">Shop All</a></li><li><a href="/collections/best-sellers">Best Sellers</a></li><li><a href="/collections/new-arrivals">New Arrivals</a></li><li><a href="/collections/for-pet-lovers">For Pet Lovers</a></li><li><a href="/collections/car-travel">For Travelers</a></li></ul></div>' +
        '<div><h2>Support</h2><ul><li><a href="/pages/about">About Us</a></li><li><a href="/pages/contact">Contact</a></li><li><a href="/pages/faq">FAQ</a></li><li><a href="/policies/shipping-policy">Shipping Policy</a></li><li><a href="/policies/refund-policy">Returns &amp; Refunds</a></li><li><a href="/policies/privacy-policy">Privacy Policy</a></li></ul></div>' +
        '<div><h2>Connect</h2><p>Get 10% off your first gift and discover new finds.</p><form class="tpg-footer-form" method="post" action="/contact#tpg-newsletter"><input type="hidden" name="form_type" value="customer"><input type="hidden" name="contact[tags]" value="newsletter"><input aria-label="Email address" type="email" name="contact[email]" placeholder="Your email" required><button type="submit">Join</button></form><div class="tpg-socials"><a href="https://www.instagram.com/thepopgift" rel="noopener" target="_blank">Instagram</a><a href="https://www.facebook.com/Thepopgift" rel="noopener" target="_blank">Facebook</a><a href="https://www.tiktok.com/@thepopgift" rel="noopener" target="_blank">TikTok</a><a href="https://www.pinterest.com/thepopgift" rel="noopener" target="_blank">Pinterest</a></div></div>' +
      '</div>';
    footer.insertBefore(shell, footer.firstChild);
  }

  function run() {
    enhanceHero();
    updateValueBadges();
    enhanceCards();
    enhancePdp();
    buildFooter();
  }

  var running = false;
  function scheduleRun() {
    if (running) return;
    running = true;
    window.requestAnimationFrame(function () {
      run();
      running = false;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  var observer = new MutationObserver(scheduleRun);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
